var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "__trans-wrapper" },
    [
      _c(
        "confirm",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTrans,
              expression: "isShowTrans"
            }
          ],
          staticClass: "trans-confirm",
          attrs: {
            title:
              _vm.transType === "transfer"
                ? _vm.$t("wallet.transfer")
                : _vm.$t("walletConversion.exchange.vite"),
            leftBtnTxt:
              _vm.transType === "transfer"
                ? _vm.$t("wallet.transfer")
                : _vm.$t("walletConversion.exchange.btn"),
            closeIcon: true,
            btnUnuse: !_vm.canTransfer,
            close: _vm.closeTrans,
            singleBtn: true,
            leftBtnClick: _vm.transfer
          }
        },
        [
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(_vm._s(_vm.$t("balance")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
              _c("img", { staticClass: "__icon", attrs: { src: _vm.icon } }),
              _vm._v(_vm._s(_vm.token.symbol) + "\n                "),
              _c("span", { staticClass: "__right" }, [
                _vm._v(_vm._s(_vm.balance))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.transType === "transfer",
                  expression: "transType === 'transfer'"
                }
              ],
              staticClass: "__row"
            },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wallet.inAddress")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isValidAddress,
                        expression: "!isValidAddress"
                      }
                    ],
                    staticClass: "__err __hint"
                  },
                  [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: {
                  valid: _vm.validAddr,
                  placeholder: _vm.$t("wallet.placeholder.addr")
                },
                model: {
                  value: _vm.toAddress,
                  callback: function($$v) {
                    _vm.toAddress = $$v
                  },
                  expression: "toAddress"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.transType === "transfer",
                  expression: "transType === 'transfer'"
                }
              ],
              staticClass: "__row"
            },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wallet.sum")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amountErr,
                        expression: "amountErr"
                      }
                    ],
                    staticClass: "__err __hint"
                  },
                  [_vm._v(_vm._s(_vm.amountErr))]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: {
                  valid: _vm.testAmount,
                  type: "number",
                  placeholder: _vm.$t("wallet.placeholder.amount")
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.transType === "exchange",
                  expression: "transType === 'exchange'"
                }
              ],
              staticClass: "__row"
            },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(_vm._s(_vm.$t("walletConversion.exchange.viteAddr")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__input_row __unuse_input" }, [
                _vm._v(_vm._s(_vm.viteAddr))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.transType === "exchange",
                  expression: "transType === 'exchange'"
                }
              ],
              staticClass: "__row"
            },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(_vm._s(_vm.$t("walletConversion.exchange.viteAmount")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__input_row __unuse_input" }, [
                _vm._v(_vm._s(_vm.balance))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("walletConversion.gas")) +
                    "\n                "
                ),
                _c("span", { staticClass: "__row_hint" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("walletConversion.aboutPrice", {
                          amount: _vm.gasTotalPrice
                        })
                      ) +
                      "\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "process",
                {
                  attrs: {
                    min: _vm.minGwei,
                    max: _vm.maxGwei,
                    default: _vm.size
                  },
                  on: { drag: _vm.setSize }
                },
                [
                  _c("div", { staticClass: "speed" }, [
                    _c("span", { staticClass: "left" }, [_vm._v("slow")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "right" }, [_vm._v("fast")])
                  ])
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }